export type I18nCache = {
  language: string;
  country: string;
};

export const localizationStorageKey = 'i18n';

export const persistLocalization = (payload: I18nCache) => {
  localStorage.setItem(localizationStorageKey, JSON.stringify(payload));
};
